import React from 'react';

type LocationClusterProps = {
    lat: number,
    lng: number,
    $hover?: boolean,
    pointCount: number,
    points: number
    onClick: () => void
}

export function LocationCluster({$hover = false, pointCount, points, onClick} : LocationClusterProps) {

    const size = 40 + (pointCount / points) * 50 + ($hover ? 4 : 0);

    const clusterStyle = {
        color: '#fff',
        background: 'rgba(67, 104, 161, .8)',
        borderRadius: '50%',
        padding: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${size}px`,
        height: `${size}px`,
        transform: 'translate(-50%, -50%)',
        fontSize: '38px',
        cursor: 'pointer',
        fontFamily: 'Open Sans ,sans-serif'
    }

    return (
        <div style={clusterStyle} onClick={onClick}>
            {pointCount}
        </div>
    );
}
